import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';

import { SimpleDropdown } from 'ui-components/components/dropdown';

import { FilterItem } from './filter-item';
import messages from './messages';
import drawerMessages from '../../../messages';
import { getForecastPeriods } from '../../../utils/time-periods';

const forecastPeriodOptions = getForecastPeriods().map((period) => ({
  value: period.key,
  label: <FormattedMessage {...period.messageDescriptor} />,
}));

/**
 * ForecastPeriodFilter component that provides a dropdown for selecting forecast period
 * @param {object} props - Component props
 * @param {string} props.value - Current selected value
 * @param {(value: string) => void} props.onChange - Callback function when value changes
 * @returns {React.ReactElement} The rendered ForecastPeriodFilter component
 */
export const ForecastPeriodFilter = ({ value, onChange }) => {
  const { formatMessage } = useIntl();

  return (
    <FilterItem
      ariaLabel={formatMessage(messages.forecastPeriodFilterAriaLabel)}
      inputComponent={
        <SimpleDropdown
          onItemSelected={onChange}
          options={forecastPeriodOptions}
          placeholder={<FormattedMessage {...messages.forecastPeriodPlaceholder} />}
          selectedItemValue={value}
        />
      }
      label={drawerMessages.dateRangeLabel}
    />
  );
};
